var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.promoCode)?_c('dl',{staticClass:"promo-code-detail"},[_c('dt',[_vm._v(_vm._s(_vm.$t('ctx.discount.detail.promo-code')))]),_c('dd',[_vm._v(_vm._s(_vm.promoCode))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }